import "./OTAManagement.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import Faq from "./sections/Faq";
import Hero from "./sections/Hero";
import Stories from "./sections/Stories";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function OTAManagementPage() {
  return <div>
      <Header />
      <Services />
      <Faq />
      <Hero />
      <Stories />
      <Consultation />
      <Footer />
    </div>;
}